<div class="row" style="margin-bottom: 100px;" *ngIf="!loader">
  <div class="col-sm-8" *ngIf="showStep1">
    <div class="content">
      <h1>New business creation (step 1 of 4)</h1>
      <div class="options">
        <div class="row">
          <div class="sub_headingt">
          <h3>Choose the kind of business
          </h3>
          </div>
          <div class="col-sm-6" *ngFor="let item of businessTypeData; let i = index">
        <mat-card >
         <div
          class="option" 
          (click)="changeBusinessType(i)" >
          <img [src]="item.assetUrl" alt="" />
          <div *ngIf="item.isSelected == 1" class="tick_opklads">
            <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
            <mat-icon
              class="material-icons-outlined"
              class="mb-1"
              style="color: #fff"
              >check</mat-icon
            >
          </div>
          <h3>{{ item.title }}</h3>
          <!-- <div class="checkmark">✔️</div> -->
        </div>
      </mat-card>
    </div>
    </div>
      </div>


      <h2 *ngIf="businessTypeData[1].isSelected == 1">Select service provider gender
      </h2>
      <div class="grid-options service-type" *ngIf="businessTypeData[1].isSelected == 1" style="border-bottom: none;">
        <div class="row">
          <div class="col-sm-6" *ngFor="let item of professsionalGender; let i= index">
            <mat-card >
          <div class="grid-item"  (click)="selectProfessionalGender(i)">
          <img [src]="item.assetUrl" alt="" />
          <div *ngIf="item.isSelected == true" class="tick_opklads">
            <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
            <mat-icon
              class="material-icons-outlined"
              class="mb-1"
              style="color: #fff"
              >check</mat-icon
            >
          </div>
        <h3>{{ item.title }}</h3>
        </div>
      </mat-card>
      </div>
      </div>
      </div>
      <h2>Select the type of service
      </h2>
      <div class="grid-options service-type">
        <div class="row">
          <div class="col-sm-6"  *ngFor="let item of toShowServiceTemplates; let i= index">
         
            <div class="grid-item" (click)="selectServiceType(i)">
              <mat-card [ngClass]="{'make-disabled': checkDisabilityForCheckBox(item)}">
          <img [src]="item.icon_url" alt="" />
          <div *ngIf="item.isSelected == true" class="tick_opklads">
            <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
            <mat-icon
              class="material-icons-outlined"
              class="mb-1"
              style="color: #fff"
              >check</mat-icon
            >
          </div>
        <h3>{{ item.name }}</h3>
      </mat-card>
        </div>


      </div>
      </div>

      </div>
      <div class="footer">
        <button (click)="cancel()" mat-button style="font-size: 16px;"> Cancel</button>

        <button
        (click)="onClickNext(1)"
        [disabled]="checkServicesSelected() || isGenderSelected()"
      mat-flat-button
      color="accent"
      class="next"
    >
      Next
    </button>
      </div>
    </div>
    </div>
  <div class="col-sm-8" *ngIf="showStep2">
    <div class="content">
      <h1>New business creation (step 2 of 4)
      </h1>
      <div class="options">
        <div class="row">
          <div class="sub_headingt">
            <h3>Mode of offering the service

            </h3>
            </div>
          <div class="col-sm-6"  *ngFor="let item of serviceTypeData; let i = index">
            <mat-card >
        <div
          class="option"
         
          (click)="selectServiceTypeData(i)"
        >
          <img [src]="item.assetUrl" alt="" />
          <div *ngIf="item.isSelected == true" class="tick_opklads">
            <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
            <mat-icon
              class="material-icons-outlined"
              class="mb-1"
              style="color: #fff"
              >check</mat-icon
            >
          </div>
          <h3>{{ item.title }}</h3>
          <!-- <div class="checkmark">✔️</div> -->
        </div>
      </mat-card>
      </div>
      </div>
        
      </div>

      <h2>Business type based on target customer
      </h2>
      <div class="grid-options service-type">
       
        <div class="row">
          <div class="col-sm-6" *ngFor="let item of serviceTypeGender; let i= index">
            <mat-card>
        <div class="grid-item"  (click)="selectServiceTypeGender(i)">
          <img [src]="item.assetUrl" alt="" />
          <div *ngIf="item.isSelected == true" class="tick_opklads">
            <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
            <mat-icon
              class="material-icons-outlined"
              class="mb-1"
              style="color: #fff"
              >check</mat-icon
            >
          </div>
        <h3>{{ item.title }}</h3>
        </div>
      </mat-card>
      </div>
      </div>

      </div>
      <div class="footer">
        <button mat-button style="font-size: 16px;" (click)="onClickBack(2)"><mat-icon>arrow_back</mat-icon> Back</button>

        <button
        (click)="onClickNext(2)"
        [disabled]="checkServiceTypeSelected() ||checkServiceTargetTypeSelected()"
      mat-flat-button
      color="accent"
      class="next"
    >
      Next
    </button>
      </div>
    </div>
    </div>
    <div class="col-sm-8" *ngIf="showStep3">
      <div class="content" style="padding-bottom: 40px;border-bottom: 1px solid #dadada;">
        <h1>New business creation (step 3 of 4)</h1>
        <div class="sub_headingt">
          <h3>Vital information of the business/service</h3>
          </div>
        <div>
          <div class="form-container add-bottom-margin">
           
            <!-- <h4>Name</h4> -->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Business/service name</mat-label>
              <input
              [(ngModel)]="newBusinessObj.name"
              placeholder="Enter name"
                matInput
                #input
              />
            </mat-form-field>
          </div>

          <!-- <div class="form-container add-bottom-margin">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Business contact number</mat-label>
              <input
              smNumericOnly
              maxlength="10"
              type="tel"
              [(ngModel)]="newBusinessObj.phone"
              placeholder="Enter phone number"
                matInput
                #input
              />
            </mat-form-field>
          </div> -->

          <div class="c_sectionmj">
            <div class="form-container add-bottom-margin">
            <div class="row">
             <div class="col-sm-3">
              <mat-form-field appearance="outline" class="country-code">
                <mat-label>Country Code</mat-label>
                <mat-select
                [(ngModel)]="entityCountryCode"
                required
                (selectionChange)="onCountrySelected($event)"
              >
                <mat-select-trigger>
                  {{ entityCountryCode.flag }} {{ entityCountryCode.name }}
                      {{ "(" + entityCountryCode.dial_code + ")" }}
                </mat-select-trigger>
                
                <mat-option>
                  <ngx-mat-select-search
                    noEntriesFoundLabel="no results found"
                    name="countrysearch"
                    placeholderLabel="Enter country name"
                    [formControl]="searchString"
                    (keyup)="onKey()"
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let country of countryList" [value]="country">
                  {{ country.flag }} {{ country.name }}
                  {{ "(" + country.dial_code + ")" }}
                </mat-option>
              </mat-select>
              </mat-form-field>
           </div>
           <div class="col-sm-9">
             <mat-form-field appearance="outline" class="phone-number">
               <mat-label>Business contact number</mat-label>
               <input matInput type="tel" placeholder="Enter business contact number"  smNumericOnly
               minLength="3"
                  maxlength="17"
               type="tel"
               [(ngModel)]="newBusinessObj.phone">
             </mat-form-field>
             </div>
           </div>
           </div>
          </div>



          <div class="form-container add-bottom-margin">
            <!-- <h4>Description</h4> -->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Business/service description
              </mat-label>
              <textarea
               [maxLength]="1000"
              [(ngModel)]="newBusinessObj.entityDesc"
              placeholder="Enter details
              "
                matInput
              ></textarea>
            </mat-form-field>
          </div>
          <div class="form-container add-bottom-margin">
            <!-- <h4>Email (optional)</h4> -->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Business E-mail (optional)
              </mat-label>

              <input
              [(ngModel)]="newBusinessObj.email"
              placeholder="Enter E-mail
              "
                matInput
                #input
              />
            </mat-form-field>
          </div>
          <div class="form-container add-bottom-margin">
            <!-- <h4>Email (optional)</h4> -->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Business website (optional)
              </mat-label>

              <input
              [(ngModel)]="newBusinessObj.business_website_address"
              placeholder="Enter E-mail
              "
                matInput
                #input
              />
            </mat-form-field>
          </div>
          <div class="form-container add-bottom-margin" >
            <!-- <h4>Owner name</h4> -->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Owner name</mat-label>

              <input
              [(ngModel)]="newBusinessObj.ownerName"
              placeholder="Enter owner name"
                matInput
                #input
              />
            </mat-form-field>
          </div>

          <!-- <div class="form-container add-bottom-margin" >
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Owner phone number
              </mat-label>
              <input
              smNumericOnly
              maxlength="10"
              type="tel"
              [(ngModel)]="newBusinessObj.ownerPhone"
              placeholder="Enter owner phone number
              "
                matInput
                #input
              />
            </mat-form-field>
          </div> -->



          <div class="c_sectionmj">
            <div class="form-container add-bottom-margin">
            <div class="row">
             <div class="col-sm-3">
              <mat-form-field appearance="outline" class="country-code">
                <mat-label>Country Code</mat-label>
                <mat-select
                [(ngModel)]="ownerCountryCode"
                required
                (selectionChange)="onCountrySelected($event)"
              >
                <mat-select-trigger>
                  {{ ownerCountryCode.flag }} {{ ownerCountryCode.name }}
                      {{ "(" + ownerCountryCode.dial_code + ")" }}
                </mat-select-trigger>
                
                <mat-option>
                  <ngx-mat-select-search
                    noEntriesFoundLabel="no results found"
                    name="countrysearch"
                    placeholderLabel="Enter country name"
                    [formControl]="searchString"
                    (keyup)="onKey()"
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let country of countryList" [value]="country">
                  {{ country.flag }} {{ country.name }}
                  {{ "(" + country.dial_code + ")" }}
                </mat-option>
              </mat-select>
              </mat-form-field>
           </div>
           <div class="col-sm-9">
             <mat-form-field appearance="outline" class="phone-number">
               <mat-label>Owner phone number</mat-label>
               <input  smNumericOnly
               minLength="3"
                  maxlength="17"
               type="tel"
               [(ngModel)]="newBusinessObj.ownerPhone"
               placeholder="Enter owner phone number
               "
                 matInput
                 #input>
             </mat-form-field>
             </div>
           </div>
           </div>
          </div>


          <div class="form-container add-bottom-margin" >
            <!-- <h4>Registration number</h4> -->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Registration number (optional)
              </mat-label>

              <input
              [(ngModel)]="newBusinessObj.referenceNo"
              placeholder="Enter registration number
              "
                matInput
                #input
              />
            </mat-form-field>
          </div>
          <div class="form-container add-bottom-margin" >
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Registration type (optional)

              </mat-label>

              <input
              placeholder="The type of registration

              "
                matInput
                #input
              />
            </mat-form-field>
          </div>

          <div class="form-container" >
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Currency: {{countryInfo ? countryInfo.currency : 'INR' }} ({{countryInfo ? countryInfo.currencySymbol : '₹' }})

              </mat-label>

              <input disabled
              placeholder="The type of registration 

              "
                matInput
                #input
              />
            </mat-form-field>
          </div>


        </div>
        
        </div>
          <div class="footer">
            <button mat-button style="font-size: 16px;" (click)="onClickBack(3)"><mat-icon>arrow_back</mat-icon> Back</button>
    
            <button
            (click)="onClickNext(3)"
            [disabled]="checkForm()"
          mat-flat-button
          color="accent"
          class="next"
        >
          Next
        </button>
          </div>
    </div>
    <div class="col-sm-8" *ngIf="showStep4">
      <div class="content" style="padding-bottom: 40px;
    border-bottom: 1px solid #dadada;">
        <h1>New business creation (step 4 of 4)</h1>
        <div class="sub_headingt">
          <h3>The business/service provider location</h3>
          </div>



        <div class="map-holder">
          <div #mapContainer id="map-container" style="height: 500px; width: 100%;"></div>

        </div>
        <div class="map-form-holder">
          <!-- <h4>Address</h4> -->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Address which people would see</mat-label>
            <input
            [(ngModel)]="formattedAddress"

            #autocomplete id="autocomplete" type="text" placeholder="Enter address"
              matInput
              #input
            />
          </mat-form-field>
        </div>
      </div>
      <div class="footer">
        <button mat-button style="font-size: 16px;" (click)="onClickBack(4)"><mat-icon>arrow_back</mat-icon> Back</button>

        <button
      (click)="onSubmit()"
      [disabled]="!formattedAddress"
      mat-flat-button
      color="accent"
      class="next"
    >
      Save
    </button>
      </div>
    </div>
        <div class="col-sm-4" *ngIf="showStep1">
          <div class="faq">
            <mat-accordion>
                <mat-expansion-panel [expanded]="panelState[0]"  (opened)="panelState[0] = true"
                                     (closed)="panelState[0] = false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      What's the difference between Business/shop and Individual professional?

                    </mat-panel-title>
                   
                  </mat-expansion-panel-header>
                  <p>Shops are larger establishments with multiple professionals offering a variety of services under one roof. Often have an established brand and reputation, which can attract clients through name recognition, loyalty programs, and marketing efforts.
                  </p>
                  <p>Individual Service Providers are typically freelance or independent professionals, such as makeup artists, hairstylists, or personal trainers, who work alone and may operate from home, rent a chair at a salon, or provide mobile services.
                  </p>
                </mat-expansion-panel>
                <mat-expansion-panel (opened)="panelState[1] = true"
                                     (closed)="panelState[1] = false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      For an individual professional, why gender is important?

                    </mat-panel-title>
                   
                  </mat-expansion-panel-header>
                  <p>Gender can be important for individual beauty professionals in the industry due to several factors related to customer preferences, cultural norms, and market segmentation. Many clients feel more comfortable receiving beauty or grooming services from someone of the same gender. This is particularly true for intimate services like waxing, massages, or certain skincare treatments.
                  </p>
                  <p>Male and female clients often have different grooming needs (e.g., beard grooming for men, hairstyling preferences for women), and beauty professionals may specialize in techniques or treatments that cater specifically to one gender.
                  </p>
                </mat-expansion-panel>
                <mat-expansion-panel (opened)="panelState[2] = true"
                                     (closed)="panelState[2] = false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Can I add multiple services in one business?

                    </mat-panel-title>
                   
                  </mat-expansion-panel-header>
                  <p>Yes, you can. But Gym/Fitness and Yoga cannot be added with the other available services and vice verse.
                  </p>
                </mat-expansion-panel>

             
              </mat-accordion>
          </div>
        </div>


        
        <div class="col-sm-4" *ngIf="showStep2">
          <div class="faq">
            <mat-accordion>
                <mat-expansion-panel [expanded]="panelState2[0]" (opened)="panelState2[0] = true"
                                     (closed)="panelState2[0] = false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      What is mode of offering the service?
                    </mat-panel-title>
                   
                  </mat-expansion-panel-header>
                  <p>In the beauty and fitness industry, services are typically offered in three main formats: shop-based, home-based, and virtual. Each format has its own unique characteristics, benefits, and challenges.
                  </p>
                  <p>Shop/in-premise services are provided in physical locations such as beauty salons, parlours or fitness centres. Shops usually offer a well-equipped, professional environment, often with high-end equipment and a variety of beauty products. Home-based services are offered either by the professional visiting the client’s home or by the client visiting the professional's home-based business. Virtual services have gained popularity, particularly due to technological advancements and the pandemic's influence. These services are delivered online through video calls, apps, or tutorials.
                  </p>
                </mat-expansion-panel>
                <mat-expansion-panel (opened)="panelState2[1] = true"
                                     (closed)="panelState2[1] = false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      What is business/service type based on customer?

                    </mat-panel-title>
                   
                  </mat-expansion-panel-header>
                  <p>In the beauty and grooming industry, 'Ladies', 'Gents', and 'Unisex' salons cater to different client demographics, offering services tailored to the needs and preferences of men, women, or both. 
                  </p>
                </mat-expansion-panel>
              
              
              </mat-accordion>
          </div>
        </div>
        <div class="col-sm-4" *ngIf="showStep3">
          <div class="faq">
            <mat-accordion>
                <mat-expansion-panel [expanded]="panelState3[0]" (opened)="panelState3[0] = true"
                                     (closed)="panelState3[0] = false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Why business/service data is important?

                    </mat-panel-title>
                   
                  </mat-expansion-panel-header>
                  <p>A well-constructed business profile helps the business in project a professional image to clients. It showcases the business’s mission, vision, values, and what makes it unique, helping to create a recognisable and credible brand in the beauty industry.
                  </p>
                  <p>A business profile often acts as the first point of contact for customers searching for beauty services. A clear, attractive profile gives a good first impression, increasing the chances of attracting new clients.
                  </p>
                </mat-expansion-panel>
                <mat-expansion-panel (opened)="panelState3[1] = true"
                                     (closed)="panelState3[1] = false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      What is registration number?

                    </mat-panel-title>
                   
                  </mat-expansion-panel-header>
                  <p>In India, beauty businesses such as salons, parlors, and spas require specific registrations, licenses, and numbers to operate legally. These registration numbers ensure compliance with various regulations, from tax laws to health and safety standards. It can be any of these - Goods and Services Tax (GST) Registration Number or Shops and Establishment License or Trade License or Professional Tax Registration or PAN (Permanent Account Number) or TAN (Tax Deduction and Collection Account Number).
                  </p>
                </mat-expansion-panel>
             
              </mat-accordion>
          </div>
        </div>
        <div class="col-sm-4" *ngIf="showStep4">
          <div class="faq">
            <mat-accordion>
                <mat-expansion-panel [expanded]="panelState4[0]" (opened)="panelState4[0] = true"
                                     (closed)="panelState4[0] = false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      How to add the location info?

                    </mat-panel-title>
                   
                  </mat-expansion-panel-header>
                  <p>You can drag the red map pointer and place it in the exact location of your business. Also you can type in the text field provided below the Map. Select your location from the auto-correct drop down while you type.
                  </p>
                </mat-expansion-panel>
           
              </mat-accordion>
          </div>
        </div>
</div>
